import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup__content" }
const _hoisted_2 = { class: "ban-user__header mb-sm" }
const _hoisted_3 = { class: "ban-user__label" }
const _hoisted_4 = {
  key: 0,
  class: "ban-user__row mb-sm"
}
const _hoisted_5 = { class: "ban-user__label" }
const _hoisted_6 = { class: "ban-user__value" }
const _hoisted_7 = { class: "ban-user__option mb-sm" }
const _hoisted_8 = {
  class: "form-check-label",
  for: "banPermanent"
}
const _hoisted_9 = {
  key: 1,
  class: "ban-user__field mb-sm"
}
const _hoisted_10 = {
  class: "ban-user__label",
  for: "banDuration"
}
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 2,
  class: "alert alert-danger mb-sm",
  role: "alert"
}
const _hoisted_13 = { class: "popup__controls" }
const _hoisted_14 = { class: "text-capitalize-first" }
const _hoisted_15 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    "hide-title": true,
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "popup__form",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.helper.trans('labels.ban_user')), 1)
          ]),
          (_ctx.userId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.user_id')) + ":", 1),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.userId), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "form-check-input",
              id: "banPermanent",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.permanent) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.permanent]
            ]),
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.permanent_ban')), 1)
          ]),
          (!_ctx.permanent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.helper.trans('labels.duration_seconds')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "banDuration",
                  class: "form-control",
                  min: "1",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.durationSeconds) = $event)),
                  placeholder: _ctx.helper.trans('labels.duration_seconds')
                }, null, 8, _hoisted_11), [
                  [
                    _vModelText,
                    _ctx.durationSeconds,
                    void 0,
                    { number: true }
                  ]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.validationError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.validationError), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)), ["prevent"])),
            class: "btn popup__close"
          }, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('button.cancel')), 1)
          ]),
          _createVNode(_component_LoaderButton, {
            "on-click": _ctx.submit,
            class: "btn btn--accept"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('button.ban')), 1)
            ]),
            _: 1
          }, 8, ["on-click"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}